import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TSystemsService } from '../../../../../api/addons/services/t-systems.service';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { ToastService } from '@app/core/services/toast.service';
import { lastValueFrom } from 'rxjs';
import { SharedModule } from '@app/shared/shared.module';

@Component({
    selector: 'app-register-organization',
    templateUrl: './register-organization.component.html',
    styleUrl: './register-organization.component.scss',
    imports: [CommonModule, SharedModule],
})
export class RegisterOrganizationComponent {
    constructor(
        public dialogRef: MatDialogRef<RegisterOrganizationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private tsystemsService: TSystemsService,
        private sessionService: SessionService,
        private toastService: ToastService,
        private translate: TranslateService
    ) {}

    cancel(): void {
        this.dialogRef.close(false);
    }

    async register() {
        try {
            await lastValueFrom(
                this.tsystemsService.replaceOrganizationConfig({
                    organizationKey:
                        this.sessionService.getSession().organizations[0]._key,
                    body: {
                        config: {
                            hasRegistered: true,
                        },
                    },
                })
            );

            this.dialogRef.close(true);
        } catch (e) {
            this.toastService.error(
                this.translate.instant(
                    'ADDONS.REGISTER_ORGANIZATION_DIALOG.ON_ERROR'
                )
            );
        }
    }
}
